export const CHUNK_TEMPLATE = '$Number$';
export const DASH_REPRESENTATION_ID_TEMPLATE = '$RepresentationID$';
